import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon3Long } from "../../assets/icons/Fork3Long.svg";
import { useNavigate } from "react-router-dom";

const IncreaseEngagementIntroData = () => {
  const navigate = useNavigate();
  const block1 = [
    {
      title: "Frictionless User Journeys",
      description:
        "Guide users directly to the content they want, effortlessly. Smart deep links remove barriers, reduce bounce rates, and ensure users consistently experience your app's value from their first click.",
      learnMore: () => navigate("/measure"),
    },

    {
      title: "Targeted, Automated Messaging",
      description:
        "Reach users with the right message at exactly the right moment. Grovs provides automated messaging tailored for new and returning users, delivering platform-specific communications seamlessly.",
      learnMore: () => navigate("/messaging"),
    },

    {
      title: "Clear, Actionable Insights",
      description:
        "Stop guessing about user behavior. Grovs gives you precise insights on app opens, reactivations, and engagement trends, helping you clearly identify what's working and refine your strategy.",
      learnMore: () => navigate("/analyse"),
    },
  ];
  const block2 = [
    {
      title: "Seamless Deep Linking",
      description:
        "Keep users engaged with seamless journeys by directing them to the right content, using deferred deep links for smooth onboarding, and editable links for quick updates without disruption.",
      learnMore: () => navigate("/engagement"),
    },

    {
      title: "Personalized Cross-Platform Messaging",
      description:
        "Keep users engaged with targeted messages via in-app, push, and inbox, while easily distinguishing between new and existing users.",
      learnMore: () => navigate("/messaging"),
    },

    {
      title: "Simplified User Engagement Analytics",
      description:
        "Understand user behavior with automatic tracking of opens, reactivations, and link clicks, plus clear dashboards and easy data export for deeper insights.",
      learnMore: () => navigate("/analyse"),
    },
  ];
  return (
    <FullPageContainer>
      <Container>
        <Content>
          <TextWrapper>
            <Title>
              Why Grovs is Your Best Choice for Increasing Engagement
            </Title>
            <Subtitle>
              Grovs delivers powerful tools that empower you to boost user
              engagement, enhance retention, and maximize lifetime value (LTV).
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3Long color="rgba(39, 16, 60, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {block1.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Core Features for Increasing Engagement</Title>
            <Subtitle>
              Grovs' smart links provide reliable insights into user flows,
              eliminating guesswork and clearly mapping journeys. Make informed
              decisions with complete visibility into user experiences.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3Long color="rgba(39, 16, 60, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {block2.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default IncreaseEngagementIntroData;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  gap: 30px;
  max-width: 850px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
      gap: 20px;
  overflow: hidden;
`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
